<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     伙伴总览
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="prm-overview mt-md">
    <el-card shadow="never">
      <el-row :gutter="20">
        <el-col :span="9">
          <div class="front-line mb">
            线索报备
          </div>
          <div role="button" class="bg-light flex-center column pl-md pr-md pb-lg pt-lg" style="height: 180px" @click="toReport">
            <div class="cube flex-center column bg-purple text-white radius5">
              <div class="iconfont icon-clue"></div>
            </div>
            <div class="mt-xs">线索报备</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="front-line mb">
            数据统计
          </div>
          <div role="button" class="bg-light radius5 flex-center column pl-md pr-md pb-lg pt-lg" style="height: 180px" @click="toClient">
            <div class="">我的客户（个）</div>
            <div class="font-4x text-primary mt-lg">{{ customer_count }}</div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="mb" style="height: 20px;">
            &nbsp;
          </div>
          <div role="button" class="bg-light radius5 flex-center column pl-md pr-md pb-lg pt-lg" style="height: 180px" @click="toClue">
            <div class="">我的线索（个）</div>
            <div class="font-4x text-primary mt-lg">{{ lead_count }}</div>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="front-line mb flex align-items-center">
            <div class="bd">授权证书</div>
            <el-button type="text" class="ft" @click="certificateShow = true">下载证书</el-button>
          </div>
          <div class="bg-light radius5 pl-md pr-md pb-lg pt-lg" style="height: 180px">
            <div class="text-bold font-md">{{ god.full_name }}</div>
            <div class="mt-hg">授权范围： {{ god.partner_auth  }}</div>
            <div class="mt-sm">授权期至： {{ god.partner_expiretime | parseTime('{y}/{m}/{d}') }}</div>
            <div class="iconfont icon-prm-b bg-icon"></div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="mt-md mb-md no-padding" shadow="never">
      <record-check @report="toClueReport" />
    </el-card>

    <clue-report v-if="clueShow" :show.sync="clueShow" :company="company" @success="fetchData" @exist="clueExist" />

    <record-check v-if="recordShow" :show.sync="recordShow" :companyid="companyid" type="dialog" @report="toClueReport" />

    <certificate-download v-if="certificateShow" :show.sync="certificateShow" :god="god" />
  </div>
</template>

<script>
import { partnerOverviewApi } from '@/api/prm/prmApi'

export default {
  name: 'PrmOverview',

  components: {
    RecordCheck: () => import('./components/RecordCheck'),
    ClueReport: () => import('./components/ClueReport'),
    CertificateDownload: () => import('./components/CertificateDownload'),
  },

  data() {
    return {
      certificateShow: false,
      loading: false,
      god: {},
      customer_count: 0,
      lead_count: 0,
      clueShow: false,
      company: {},
      recordShow: false,
      companyid: '',
    }
  },

  computed: {
  },


  created() {
    this.fetchData()
  },

  methods: {
    toReport() {
      this.company = Object.assign({})
      this.clueShow = true
    },

    toClueReport(company) {
      this.company = Object.assign({}, company)
      if (this.recordShow) {
        this.recordShow = false
      }
      setTimeout(() => {
        this.clueShow = true
      }, 500)
    },

    fetchData() {
      this.loading = true
      partnerOverviewApi().then(res => {
        if (!res.errno) {
          this.loading = false
          this.god = Object.assign({}, res.data.god)
          this.customer_count = res.data.customer_count
          this.lead_count = res.data.lead_count
        } else {
          this.$message.error(res.message)
        }
      })
    },

    clueExist(id) {
      this.companyid = id
      setTimeout(() => {
        this.recordShow = true
      }, 500)
    },

    toClient() {
      this.$router.push({
        path: '/prm/client',
      })
    },

    toClue() {
      this.$router.push({
        path: '/prm/clue',
      })
    },

  }
}
</script>

<style lang="scss" scoped>
.prm-overview {
  .front-line {
    height: 20px;
  }
  .cube {
    width: 60px;
    height: 60px;
    line-height: 60px;
    font-size: 56px;
  }
  .bg-icon {
    position: absolute;
    bottom: 0px;
    right: 15px;
    font-size: 120px;
    line-height: 120px;
    color: rgba(7,193,96,0.07);
  }
  .no-padding {
    /deep/ .el-card__body {
      padding: 0 0;
    }
  }
}
</style>
